import { useEffect, useState } from 'react';
import { logBookingError } from '../loggingUtils';

const loadLabelsByLanguage = async (language: string) => {
    const labelModule = await import(
        `../../../externals/cal-locales/${language}.json?raw`
    );
    return JSON.parse(labelModule.default);
};

const useBookerLabels = (language: string) => {
    const [labels, setLabels] = useState<Record<string, string> | undefined>(
        undefined
    );
    const [labelsLoaded, setLabelsLoaded] = useState(false);

    useEffect(() => {
        const loadLabels = async () => {
            try {
                if (language) {
                    const labels = await loadLabelsByLanguage(language);
                    setLabels(labels);
                }
            } catch (error) {
                logBookingError('Failed to load labels', {
                    language,
                    errorMessage:
                        // Type guard to handle the error case
                        error instanceof Error
                            ? error.message
                            : 'Unknown error',
                });
            } finally {
                setLabelsLoaded(true);
            }
        };

        loadLabels();
    }, [language]);

    return { labels, labelsLoaded };
};

export default useBookerLabels;
